<template>
  <div class="page about">
    <b-container>
      <section class="section">
        <h1 class="h1 semibold mb-2">Chi siamo</h1>
        <p>
          La nostra società è leader in Italia nella fornitura di soluzioni
          business di online travel booking. Le nostre soluzioni vengono
          utilizzate da alcune tra le più innovative aziende italiane nel
          welfare aziendale, nel marketing, nei piani loyalty e nelle
          incentivazioni aziendali al trade.
        </p>
        <p>
          Ci avvaliamo di avanzate tecnologie IT e di collaborazioni con i
          leader globali del travel online ma manteniamo anche una
          caratterizzazione territoriale. Infatti, tutto il nostro staff, dallo
          sviluppo tecnologico all'assistenza clienti passando per lo sviluppo
          strategico e commerciale, si trova nella nostra sede in provincia di
          Rimini.
        </p>
      </section>
      <section class="section">
        <info-banner
          title="La nostra mission"
          image="/assets/images/liveflight/about/about-1.jpg"
          :description="`
            <span class='d-flex flex-column'>
              <span class='mb-1'>
                La nostra mission è quella di realizzare soluzioni di travel booking fortemente
                orientate all'utente.
              </span>
              <span>
                Lo sviluppo tecnologico e la cura dell'assistenza clienti danno sicurezza e
                tranquillità ai viaggiatori che prenotano con
                ${site.brand}. Le aziende che affidano i loro dipendenti e i loro clienti ai nostri
                servizi sanno di poter contare su un servizio a loro dedicato che non trova riscontro
                negli altri player del settore.
              </span>
            </span>`"
          direction="left"
        />
      </section>

      <section class="section">
        <hr />
      </section>

      <content-section
        icon="quote"
        :title="`${site.payoff} ${site.brand}`"
        :description="`${site.payoff} ${site.brand} è un sito di prenotazione voli
            facile e semplice da usare che ti permette di avere accesso ai
            servizi proposti sui circuiti internazionali da tutte le principali
            compagnie aeree tradizionali e low cost in Italia, in Europa e nel
            mondo.`"
      />

      <section class="section">
        <hr />
      </section>

      <section class="section">
        <info-banner
          title="Contatti"
          image="/assets/images/liveflight/about/about-2-2.jpg"
          :description="`
            <span class='d-flex flex-column'>
              <span class='mb-4'>
                ${site.payoff} ${site.brand} è un servizio di Salabam srl
              </span>
              <ul class='dashed'>
              <li>
                <b>Assistenza clienti:</b>
                <a href='mailto:${site.emailSupport}'>
                  ${site.emailSupport}</a>
              </li>
              ${
                site.emailBusiness !== ''
                  ? `
                <li>
                  <b>Servizi business:</b>
                  <a href='mailto:${site.emailBusiness}'>
                    ${site.emailBusiness}
                  </a>
                </li>
              `
                  : ''
              }
              <li><b>Telefono:</b> ${site.phoneNumber}</li>
              ${
                site.waIntentLink !== '' && site.mobileNumber !== ''
                  ? `
                <li>
                  <b>Whatsapp:</b>
                  <a href='${site.waIntentLink}'>
                    ${site.mobileNumber}
                  </a>
                </li>
              `
                  : site.mobileNumber !== ''
                    ? `
                <li>
                  <b>Whatsapp:</b> ${site.mobileNumber}
                </li>
              `
                    : ''
              } 
            </ul>
            </span>`"
        />
      </section>

      <section class="section">
        <hr />
      </section>

      <section class="section">
        <div class="static-page__form" id="contattaci">
          <b-container>
            <form-contatti
              :formTitle="title_request_form"
              :formSubTitle="subtitle_request_form"
              :label="'form-contatti-about'"
              :recipient="site.emailSupport"
            />
          </b-container>
        </div>
      </section>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import InfoBanner from "@/components/blocks/info-banner.vue";
import FormContatti from "@components/blocks/form-contatti.vue";
import ContentSection from "@liveflight/components/blocks/wrappers/content-section";

export default {
  name: "about",
  components: {
    "info-banner": InfoBanner,
    "content-section": ContentSection,
    "form-contatti": FormContatti,
  },
  props: {
    footerMenu: String,
    btnText: String,
  },
  data() {
    return {
      title_request_form: `Hai bisogno di <span class="text-secondary">maggiori informazioni?</span> Contattaci!`,
      subtitle_request_form:
        "Compila il seguente form oppure scrivi a uno dei contatti elencati sopra!",
      site: Vue.prototype.$config.site,
    };
  },
};
</script>

<style lang="scss">
.about {
  ul {
    margin: 0;

    li {
      margin-bottom: 10px;
    }
  }

  ul.dashed {
    list-style-type: none;
  }

  ul.dashed > li:before {
    content: "-";
    /*text-indent: -5px;*/
  }
}
</style>
